import React from 'react';
import Obfuscate from 'react-obfuscate';


function Imprint() {
	return (

		<div className="airy">
			<div className="row">
				<h1>Imprint</h1>

				<div className="col-lg">The Arab-German Young Academy of Sciences and Humanities (AGYA)<br />
					at the Berlin-Brandenburg Academy of Sciences and Humanities (BBAW)<br />
					Matthias Pasdzierny<br />
					Jägerstr. 22–23<br />
					10117 Berlin/Germany
				</div>
				<div className="col-lg">
					<h2><br /><Obfuscate email="info@apsearch.org">Contact us!</Obfuscate></h2>
				</div>
			</div>
		</div>

	);
}

export default Imprint;